import { initializeApp } from "firebase/app";
import { auth } from "./matuAuth";
import { database } from "./matuRtdb";
import { getStorage } from "./matuStorage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDrEAUTO8AkiqVC1P7vhdV79_7Nny_GWXM",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "towin-fe4cc.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "towin-fe4cc",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "towin-fe4cc.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "352819961674",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:352819961674:web:675ae57425c3e3c605abb3",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-YKE283R84E",
};

const app = initializeApp(firebaseConfig);
const storage = getStorage();

export { app, auth, database, storage };
